import React, { createContext, useEffect, useState } from "react";
import toast, { Toaster } from "react-hot-toast";
import { useHistory, useLocation } from "react-router-dom";
import { getSubDomain } from '../../hooks/getSubDomain';
import Cookie from "js-cookie";

import { api } from "../../services/api";

import type { 
  AuthProviderProps, 
  ISignInResponse, 
  IUserProps, 
  signInCredentials,
} from "./types";

interface AuthContextData {
  signIn: (credentials: signInCredentials) => Promise<void>;
  signOut: () => void;
  activeCity: number | null;
  handleCity:(e: number) => void;
  user: IUserProps | undefined;
}

export const AuthContext = createContext({} as AuthContextData); 

export function AuthProvider({ children }: AuthProviderProps) {
  const history = useHistory();
  const location = useLocation();
  const [activeCity, setActiveCity] = useState<number | null>(() => {
    const city = localStorage.getItem("cityid");
    if(city) return Number(city);
    return null;
  })

  useEffect(() => {
    if(activeCity && location.pathname === "/notcity") history.push("/usuariosapps")
  },[activeCity])

  function handleCity(city: number) {
    setActiveCity(city);
    localStorage.setItem("cityid", String(city))
  }
  const [user, setUser] = useState<IUserProps | undefined>(() => {
    const userCookie = Cookie.get("whats-front-user");

    if(userCookie) return JSON.parse(userCookie);
    return undefined;
  });

  useEffect(() => {
    const token = Cookie.get('whats-front-token');
    if (token) {
      api.defaults.headers.common.authorization = `Bearer ${token}`;
    }
  }, []);

  async function signIn({ email, password }) {
    try {
      const { data: { token, user } } = await api.post<ISignInResponse>(getSubDomain() +'auth/login', {
        email,
        password,
      });

      api.defaults.headers.common.authorization = `Bearer ${token.accessToken}`;

      Cookie.set('whats-front-token', token.accessToken, {
        expires: new Date(Date.now() + 1000 * 60 * 60 * 24), // one day
      });

      Cookie.set('whats-front-user', JSON.stringify(user), {
        expires: new Date(Date.now() + 1000 * 60 * 60 * 24), // one day
      });

      setUser(user);
      toast.success(`Seja bem vindo, ${user.firstName}!`)

      history.push('/estudantes');
    } catch (err: any) {
      if(err.response.data.message === "error.userNotFound") {
        toast.error("Usuário não encontrado");
      } 

      if(err.response.data.message === "error.passwordInvalid") {
        toast.error("Senha incorreta");
      } 

      if(err.response.data.message.message === "error.userNotFound") {
        toast.error("Usuário não encontrado");
      } 

      if(err.response.data.message.message === "error.passwordInvalid") {
        toast.error("Senha incorreta");
      } 
    };
  }

  function signOut() {
    Cookie.remove("whats-front-token");
    history.push("/");
  }

  return (
    <AuthContext.Provider value={{ user, signIn, signOut, activeCity, handleCity }}>
      <Toaster 
        position="top-right"
        reverseOrder={false}
      />
      
      {children}
    </AuthContext.Provider>
  );
}
